import { PageTypeId } from '../../const';
import { MODULE_PATHS } from '../../../../utils/const';
import { navigationCodes } from '../../../../data/translations/navigationCodes';
import { CommonNavigationStrategy } from '../common/strategy';

export class CandidateUserStrategy extends CommonNavigationStrategy {
	private readonly organizationId: number;

	constructor(organizationId) {
		super();
		this.organizationId = organizationId;
	}

	override getSchema = () => {
		const baseSchema = super.getSchema();

		return {
			...baseSchema,
			userNavigationItems: baseSchema.userNavigationItems.map((i) => {
				if (i.pageTypeId === PageTypeId.CandidateList) {
					return { ...i, titleCode: navigationCodes.candidateMyProfile };
				}

				if (i.pageTypeId === PageTypeId.EmployerList) {
					return { ...i, titleCode: navigationCodes.employerList };
				}

				if (i.pageTypeId === PageTypeId.PayslipList) {
					return { ...i, titleCode: navigationCodes.payslipList };
				}

				if (i.pageTypeId === PageTypeId.PaymentList) {
					return { ...i, titleCode: navigationCodes.paymentList };
				}

				return i;
			}),
		};
	};

	override getTitleCodes = () => {
		const titleOverride = {
			[PageTypeId.CandidateList]: navigationCodes.candidateMyProfile,
		};

		return Object.assign({}, super.getTitleCodes(), titleOverride);
	};

	override getUrls = () => {
		const urlOverride = {
			[PageTypeId.CandidateList]: `${MODULE_PATHS.candidateCommonDetailsNew}/${this.organizationId}`,
		};

		return Object.assign({}, super.getUrls(), urlOverride);
	};
}
